<template>
    <div class="c_table_wrap">
        <table>
            <colgroup>
                <col width="200px;">
                <col width="">
            </colgroup>
            <tr>
                <td class="c_t_title">이미지</td>
                <td>
                    <div>
                        <div :style="`background-image: url(${returnImage()}); width: 580px;height: 373px;cursor: pointer;
                        background-size : contain;`"></div>
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">의뢰번호</td>
                <td>
                    <div>
                        {{ itemData.l_uuid }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">이미지 촬영일자</td>
                <td>
                    <div>
                        {{ returnDateFormat(itemData.l_date, 'YYYY-MM-DD HH:mm:ss') }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">이미지 등록일자</td>
                <td>
                    <div>
                        {{ returnDateFormat(returnItem().created, 'YYYY-MM-DD HH:mm:ss') }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">이미지 검출일자</td>
                <td>
                    <div>
                        {{ returnDateFormat(itemData.detect_date, 'YYYY-MM-DD HH:mm:ss') }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">촬영 / 생성장소</td>
                <td>
                    <div>
                        {{ itemData.l_place }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">이메일</td>
                <td>
                    <div>
                        {{ itemData.l_email }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">휴대전화번호</td>
                <td>
                    <div>
                        {{ itemData.l_hp }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">적발 페이지 제목</td>
                <td>
                    <div>
                        {{ itemData.dr_title }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">적발 페이지 URL</td>
                <td>
                    <div>
                        {{ itemData.dr_page }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">적발 이미지 URL</td>
                <td>
                    <div>
                        {{ itemData.dr_image }}
                    </div>
                </td>
            </tr>
            <tr>
                <td class="c_t_title">증빙 URL</td>
                <td>
                    <div class="detail_text url" v-if="!isEmpty(itemData.l_url_1)">{{ itemData.l_url_1 }}</div>
                    <div class="detail_text url" v-if="!isEmpty(itemData.l_url_2)">{{ itemData.l_url_2 }}</div>
                    <div class="detail_text url" v-if="!isEmpty(itemData.l_url_3)">{{ itemData.l_url_3 }}</div>

                </td>
            </tr>


            <tr>
                <td class="c_t_title">증빙 파일</td>
                <td>
                    <div>
                        <span class="hover" @click="awsS3Download('lawsuit', itemData.File[0],itemData.l_idx)">{{
                                returnFileName()
                            }}</span>
                    </div>
                </td>
            </tr>

        </table>
        <div class="sub_title mt10 mb10">의뢰 진행 사항</div>
        <table>
            <colgroup>
                <col width="80px"/>
                <col width="140px"/>
                <col width="260px"/>
                <col width="800px"/>
            </colgroup>
            <tr class="rp_header">
                <td colspan="1" class="c_t_title">no</td>
                <td colspan="1" class="c_t_title">진행일</td>
                <td colspan="1" class="c_t_title">상태</td>
                <td colspan="1" class="c_t_title">설명</td>
            </tr>
            <tr class="rp_list" v-for="(log,index) in returnLog()" :key="`lawLog${log.ll_idx}`"
                v-if="returnDetectStatus(log.l_status) != false">
                <td colspan="1" class="text_center">{{ returnLog().length - index }}</td>
                <td colspan="1" class="text_center">{{ returnDateFormat(log.created_at, 'YYYY-MM-DD HH:mm:ss') }}</td>
                <td colspan="1" class="text_center">{{ (returnDetectStatus(log.l_status).name) }}</td>
                <td colspan="1" class="text_center">{{ returnDetectStatus(log.l_status).explanation }}</td>
            </tr>
        </table>
        <item-detection-status-component v-if="itemData.hasOwnProperty('l_idx')" :detectionKey="itemData.l_idx"
                                         :status="itemData.l_status"
                                         :beforePrice="itemData.l_price"></item-detection-status-component>
        <!--        <history-list-component :history-type="'detectionRequestHistory'"></history-list-component>-->
    </div>

</template>

<script>
import HistoryListComponent from "@/components/history/HistoryListComponent";
import dateMixins from "@/mixins/dateMixins";
import imageOption from "@/mixins/imageOption";
import util from "@/mixins/util";
import {detectionStatus} from "@/service/itemService";
import ItemDetectionStatusComponent from "@/components/item/ItemDetectionStatusComponent";
import awsS3FileDownload from "@/mixins/awsS3FileDownload";

export default {
    name: "ItemWriteDetectionRequestLayout",
    mixins: [dateMixins, imageOption, awsS3FileDownload],
    components: {
        ItemDetectionStatusComponent,
        HistoryListComponent
    },
    inject: [],
    provide() {
        return {}
    },
    props: {
        itemData: {
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        returnCommas(x = 0) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        returnImage() {
            if (util.isEmpty(this.returnItem()) || util.isEmpty(this.returnItem().ItemFile) || util.isEmpty(this.returnItem().ItemFile.Item)) {
                return "";
            }
            return `${this.returnItem().ItemFile.Item[0].org_url}?${this.setImageOptions(580, 373, 'jpg')}`
        },
        openImageFile(image) {
            let url = ''
            if (!util.isEmpty(image)) {
                url = image[0].org_url
            }
            window.open(url, '_blank');
        },
        returnItem() {
            if (util.isEmpty(this.itemData.Item)) {
                return {};
            }
            return this.itemData.Item
        },
        isEmpty(data) {
            return util.isEmpty(data);
        },
        returnLog() {
            return util.isEmpty(this.itemData.Log) ? [] : this.itemData.Log;
        },
        returnDetectStatus(value) {
            let keys = Object.keys(detectionStatus)
            let key = keys.filter(status => Number(status) === value);
            if (util.isEmpty(key)) {
                return '-'
            }
            return detectionStatus[key]
        },
        returnFileName() {
            let files = []
            if (this.itemData.hasOwnProperty('File') && !util.isEmpty(this.itemData.File)) {
                files = this.itemData.File
            }
            if (!util.isEmpty(files) && !util.isEmpty(files[0].org_name)) {
                return files[0].org_name
            } else {
                return '-'
            }
        },
        awsS3Download(type, name, key, nft) {
            this.runDownloadFileInfo(type, name, key, nft).then(res => {
                if (!res) {
                    this.errorAlert('파일 다운로드에 실패하였습니다.');
                }

            })
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
